import styled from 'styled-components';

export const Wrapper = styled.div`
  h1 {
    margin-bottom: var(--gap);
  }
`;

export const PlanAndFeaturesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media screen and (min-width: 960px) {
    flex-direction: row;
    gap: 120px;
  }
`;
